import React from 'react';
export function FeatureCards() {
  return <section className="px-4 md:px-8 py-12 max-w-7xl mx-auto" data-id="element-18">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-5" data-id="element-19">
        {/* Card 1 - Light */}
        <div className="lg:col-span-2 bg-[#F0F0F3] rounded-3xl flex flex-col sm:flex-row items-center relative overflow-hidden border border-dashed border-black/10 min-h-[380px]" data-id="element-20">
          <div className="w-full sm:w-[45%] h-full flex items-center justify-center p-4 sm:p-0 sm:-ml-4" data-id="element-21">
            <img src="https://cdn.magicpatterns.com/uploads/jNn5HsiSPz21aPuji2wSMW/mundo_medium.png" alt="Mundo 3D" className="w-[130%] max-w-none h-auto object-contain drop-shadow-xl" data-id="element-22" />
          </div>
          <div className="w-full sm:w-[55%] p-8 flex flex-col justify-center h-full z-10" data-id="element-23">
            <h3 className="text-[24px] font-bold text-black mb-12 leading-tight text-center sm:text-left" data-id="element-24">
              Tu negocio en piloto automático.
            </h3>
            <p className="text-[14px] text-gray-600 leading-relaxed text-center sm:text-right" data-id="element-25">
              Convierte leads en clientes de forma orgánica.
              <br className="hidden sm:block" data-id="element-26" />
              Valuán gestiona tus embudos, correos y seguimientos
              <br className="hidden sm:block" data-id="element-27" />
              mientras tú te enfocas en cerrar tratos.
            </p>
          </div>
        </div>

        {/* Card 2 - Blue */}
        <div className="lg:col-span-1 bg-[#1F46D5] text-white rounded-3xl p-8 flex flex-col justify-center gap-6 border border-dashed border-white/30 min-h-[380px]" data-id="element-28">
          <h3 className="text-[24px] font-bold leading-tight text-center" data-id="element-29">
            Cierra ventas
            <br data-id="element-30" />
            en segundos.
          </h3>
          <p className="text-[14px] text-white/80 leading-relaxed text-center" data-id="element-31">
            No dejes que tus leads se enfríen. Responde todo desde un solo
            lugar.
          </p>
        </div>

        {/* Card 3 - Blue */}
        <div className="lg:col-span-1 bg-[#1F46D5] text-white rounded-3xl p-8 flex flex-col justify-center gap-6 border border-dashed border-white/30 min-h-[380px]" data-id="element-32">
          <h3 className="text-[24px] font-bold leading-tight text-center" data-id="element-33">
            Control absoluto
            <br data-id="element-34" />
            24/7.
          </h3>
          <p className="text-[14px] text-white/80 leading-relaxed text-center" data-id="element-35">
            Monitorea cada etapa de tu proceso de ventas con analíticas en
            tiempo real.
          </p>
        </div>
      </div>
    </section>;
}